import UserForm from '../models/UserForm';
import { AxiosResponse } from 'axios';

const UpdateProfileMock = (data: UserForm): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (hasAnyEmptyAttribute(data)) {
        reject({
          response: {
            data: {
              message: 'Error validation',
              formData: data,
            },
            status: 422,
          },
        });
      } else {
        resolve({
          data: {
            message: 'Dados atualizados com sucesso!',
          },
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
        });
      }
    }, 150);
  });
};

/**
 * Verifica se todos os campos do formulário estão preenchidos.
 * Se qualquer um dos campos estiver vazio retorna true
 */
function hasAnyEmptyAttribute(formData: UserForm): boolean {
  if (
    formData.title === '' ||
    formData.document === '' ||
    formData.phone === '' ||
    formData.email === '' ||
    formData.zipcode === '' ||
    formData.address === '' ||
    formData.number === '' ||
    formData.complement === '' ||
    formData.neighborhood === '' ||
    formData.state_id === '' ||
    formData.city_id === ''
  ) {
    return true;
  }

  return false;
}

export default UpdateProfileMock;
